import { Button, Table, OverlayTrigger, Popover, Container } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setIsLoading } from '../general/actions';
import { currencyFormater } from '../general/utils';
import ProductImage from '../general/productImage';


function OrderDetails(props) {
    const { setIsLoading, readonly } = props;

    const [products, setProducts] = useState(props.products);
    const [itemsToDelete, setItemsToDelete] = useState(props.itemsToDelete);
    const [totalOrder, setTotalOrder] = useState(props.totalOrder);

    useEffect(() => { setProducts(props.products); }, [props.products]);
    useEffect(() => { setAllTotalOrder(); }, [products]);
    useEffect(() => { props.setTotalOrder(totalOrder); }, [totalOrder]);
    useEffect(() => { setItemsToDelete(props.itemsToDelete); }, [props.itemsToDelete]);

    const openImg = (e) => {
        // propagate to parent AlertModal via img click — keep existing behavior
    };

    const deleteProduct = (id, idToDelete) => {
        if (idToDelete) props.setItemsToDelete([...itemsToDelete, idToDelete]);
        props.setProducts(products.filter(p => p.id !== id));
    };

    const setQuantity = (item, quantity) => {
        quantity = Math.max(1, parseInt(quantity) || 1);
        props.setProducts(products.map(x => x.id === item.id ? { ...x, quantity } : { ...x }));
    };

    const setAllTotalOrder = () => {
        const total = props.products.reduce((acc, p) => acc + calculateItemTotal(p), 0);
        setTotalOrder(total);
    };

    const calculateItemTotal = (item) =>
        Math.round(parseFloat(item.price) * parseInt(item.quantity) * ((parseFloat(item.taxes) / 100) + 1));

    if (!products.length) return null;

    return (
        <>
            <Table responsive className="order-details-table mb-0">
                <thead>
                    <tr>
                        <th style={{ width: 52 }}></th>
                        <th>Producto</th>
                        <th className="d-none d-md-table-cell">Descripción</th>
                        <th className="d-none d-lg-table-cell">Tipo</th>
                        <th>Precio</th>
                        <th className="d-none d-sm-table-cell">IVA</th>
                        <th>Cantidad</th>
                        <th>Total</th>
                        {!readonly && <th style={{ width: 44 }}></th>}
                    </tr>
                </thead>
                <tbody>
                    {products.map(item => (
                        <tr key={'detail-' + item.id}>
                            <td>
                                <ProductImage url={item.img_url} alt={item.name} className="pointer order-detail-thumb" onClick={openImg} />
                            </td>
                            <td>
                                <div className="order-detail-name">{item.name}</div>
                                <div className="order-detail-extid">{item.ext_id}</div>
                            </td>
                            <td className="d-none d-md-table-cell">
                                {item.description ? (
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Popover id={`desc-det-${item.id}`}>
                                                <Container>{item.description}</Container>
                                            </Popover>
                                        }
                                    >
                                        <span className="order-detail-desc">
                                            {item.description.slice(0, 60)}{item.description.length > 60 ? '…' : ''}
                                        </span>
                                    </OverlayTrigger>
                                ) : '—'}
                            </td>
                            <td className="d-none d-lg-table-cell">
                                <span className="order-detail-type-badge">{item.product_type?.name}</span>
                            </td>
                            <td>{currencyFormater(item.price)}</td>
                            <td className="d-none d-sm-table-cell">{item.taxes}%</td>
                            <td>
                                {readonly ? (
                                    <span className="order-detail-qty">{item.quantity}</span>
                                ) : (
                                    <div className="qty-stepper">
                                        <button
                                            type="button"
                                            onClick={() => setQuantity(item, parseInt(item.quantity) - 1)}
                                            disabled={item.quantity <= 1}
                                        >
                                            <i className="fa fa-minus" />
                                        </button>
                                        <input
                                            type="number"
                                            value={item.quantity}
                                            min={1}
                                            onChange={(e) => setQuantity(item, e.target.value)}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setQuantity(item, parseInt(item.quantity) + 1)}
                                        >
                                            <i className="fa fa-plus" />
                                        </button>
                                    </div>
                                )}
                            </td>
                            <td><strong>{currencyFormater(calculateItemTotal(item))}</strong></td>
                            {!readonly && (
                                <td>
                                    <button
                                        type="button"
                                        className="order-detail-delete-btn"
                                        title="Eliminar producto"
                                        onClick={() => deleteProduct(item.id, item.id_detail)}
                                    >
                                        <i className="fa fa-trash" />
                                    </button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </Table>

            <div className="order-total-row">
                <span className="order-total-label">Total del pedido</span>
                <span className="order-total-amount">{currencyFormater(totalOrder)}</span>
            </div>
        </>
    );
}

function mapStateToProps(state) {
    return { isLoading: state.isLoading };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);
